import './paragonvillagesplitsville/style';
import FormStructure from './paragonvillagesplitsville/form_structure';

export default FormStructure;



// WEBPACK FOOTER //
// /Users/leila/dev/inquiry-renderer/client_forms/includes.js